import { PriceBookAccountingCodeModel, PriceModel } from "./price-book.model";
import { CodeTypeModel } from "@fs/models/code-type.model";

export class MaterialItemModel{
        ID: string
        ItemNumber: string
        IsFrequentlyUsed: boolean
        Description: string
        AccountingCode: PriceBookAccountingCodeModel
        Note: string
        IsSellable:boolean
        Cost:string
        IsPriceEditAllowed:boolean
        IsDescriptionEditAllowed: boolean
        IsDiscountExcluded:boolean
        IsTaxable:boolean
        IsAgreementExcluded:boolean
        Prices:PriceModel[]
        MaterialDetails:Item
        IsActive:boolean
        Category: Category
        Attachments: Attachment[]
        ModifyDate
        PriceBookItem: any;
        public constructor(){
            this.ID = "";
            this.ItemNumber = "";
            this.IsFrequentlyUsed = false;
            this.Description = "";
            this.AccountingCode = new PriceBookAccountingCodeModel();
            this.Note = "";
            this.IsSellable = false;
            this.Cost = "0";
            this.IsPriceEditAllowed = false;
            this.IsDescriptionEditAllowed = false;
            this.IsDiscountExcluded = false;
            this.IsTaxable = false;
            this.IsAgreementExcluded=false;
            this.Prices = [new PriceModel()];
            this.MaterialDetails = new Item();
            this.IsActive = true;
            this.Category = new Category();
            this.Attachments = [new Attachment()];
            this.ModifyDate = "";
        }
    }

export class Item{
    ID: string
    BaseUOM: CodeTypeModel
    StandardCost: string
    Description: string
    DefaultReplenishmentMethod: CodeTypeModel
    LeadTime: string
    Manufacturer:CodeTypeModel
    ManufacturerPartNumber:string
    IsReturnable:boolean
    BlockedFromReordering: boolean
    
    public constructor(){
        this.ID="",
        this.BaseUOM = new CodeTypeModel(),
        this.StandardCost = '0',
        this.Description = '',
        this.DefaultReplenishmentMethod = new CodeTypeModel(),
        this.LeadTime = '0',
        this.Manufacturer = new CodeTypeModel(),
        this.ManufacturerPartNumber = "",
        this.IsReturnable = false,
        this.BlockedFromReordering = false
    }
}

export class Attachment{
    ID?: string
    FilePath: string
    Description: string
    FileName: string
    IsDefaultImage: boolean
    IsDirty: boolean
    Uid: string
    ExternalAttachment:ExternalAttachment
    public constructor() {
        this.ID = "",
        this.IsDirty = true,
        this.IsDefaultImage = false;
        this.ExternalAttachment=new ExternalAttachment();
    }
}

export class Category{
    ID: string;
    ImagePath: string;
    IsDirty: boolean;
    IsSealed: boolean;
    IsVisible: boolean;
    ItemCounnt: number;
    Name: string;
    FullName: string;
    ParentID: string;
    SortOrder: string;
    Children: Category[];
}

export class ExternalAttachment {
    ID:string;
    IsDirty:boolean;
    ModifyDate;
    ExternalUrl:string;
    AttachmentPath:string;
    FileName:string;
    constructor() {
        this.ID="";
        this.IsDirty=false;        
    }
}